import { CustomIndexingLookupModel } from '@/types';
import { MStorePopupHelper } from './mStorePopupHelper';

export const CustomIndexingLookupsHelper = {
  methods: {
    useCustomIndexingLookup(customIndexingLookupButton: CustomIndexingLookupModel) {
      MStorePopupHelper.methods.openModal();
      MStorePopupHelper.methods.setComponent(customIndexingLookupButton.componentName);
      MStorePopupHelper.methods.setTitle(customIndexingLookupButton.titleText);
    },
    closeModal() {
      MStorePopupHelper.methods.closeModal();
    }
  }
};
